import { render, staticRenderFns } from "./HistoryPage.vue?vue&type=template&id=a7b56bfa&scoped=true"
import script from "./HistoryPage.vue?vue&type=script&lang=ts"
export * from "./HistoryPage.vue?vue&type=script&lang=ts"
import style0 from "./HistoryPage.vue?vue&type=style&index=0&id=a7b56bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b56bfa",
  null
  
)

export default component.exports